import { render, staticRenderFns } from "./AlarmSetup.vue?vue&type=template&id=b553bdf0&scoped=true"
import script from "./AlarmSetup.vue?vue&type=script&lang=ts"
export * from "./AlarmSetup.vue?vue&type=script&lang=ts"
import style0 from "./AlarmSetup.vue?vue&type=style&index=0&id=b553bdf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b553bdf0",
  null
  
)

export default component.exports